import { fromFetch } from 'rxjs/fetch';
import { switchMap, catchError, of } from 'rxjs';

/**
 * Fetches a brochure PDF blob using fromFetch.
 * @param {string} url - The URL to fetch the PDF from.
 * @returns {Observable<Blob|null>} An Observable emitting the Blob or null if fetch failed.
 */
const fetchBrochureBlob = (url) => fromFetch(url, {
        credentials: 'include',
        headers: { 'Content-Type': 'application/pdf' },
    }).pipe(
        switchMap((response) => {
            if (response.ok) {
                return response.blob();
            } 
                return of(null);
            
        }),
        catchError(() => of(null)) // In case of network error or other fetch issues
    );

export default fetchBrochureBlob;
